.button {
  display: inline;
  vertical-align: middle;
  &:focus-visible {
    z-index: var(--dds-zindex-absolute-element);
  }
}
